module.exports = __webpack_public_path__ + "media/images/emblems/Wappeneggerberg-f342c5bd8a45080d3983fd64d6d8ea5e.png";